// "Die KI denkt" - die Anzeige, solange eine Antwort unterwegs ist.
//
// Wunsch des Nutzers (23.09.2026): "eine Art Ladeicon, was sich bewegt, wenn
// die KI noch ueberlegt, oder Balken - irgendwas, was gut aussieht und was
// hermacht". Eine Runde dauert zehn Sekunden bis eine Minute; ohne sichtbare
// Bewegung wirkt das wie ein Haenger. Deshalb: ein drehender Ring in den
// Hausfarben, wechselnde Zeilen, was gerade passiert, ein laufender Balken und
// die vergangenen Sekunden.
//
// Die Zeilen sind bewusst allgemein - sie beschreiben die Arbeitsschritte,
// behaupten aber nicht, welcher gerade laeuft. Das weiss die Seite nicht.

import React, { useEffect, useState } from 'react';
import { T } from '../../lib/designTokens';

const WECHSEL_MS = 2600;

export default function KiDenkt({ schritte = ['Die KI denkt nach …'] }) {
  const [schritt, setSchritt] = useState(0);
  const [sekunden, setSekunden] = useState(0);

  useEffect(() => {
    const beginn = Date.now();
    const uhr = setInterval(() => setSekunden(Math.floor((Date.now() - beginn) / 1000)), 1000);
    const wechsel = setInterval(() => setSchritt((v) => (v + 1) % schritte.length), WECHSEL_MS);
    return () => { clearInterval(uhr); clearInterval(wechsel); };
  }, [schritte.length]);

  return (
    <div role="status" aria-live="polite" style={{
      alignSelf: 'flex-start', minWidth: 240, maxWidth: '88%',
      background: T.flaeche, border: `1px solid ${T.randWeich}`,
      borderRadius: '12px 12px 12px 4px', padding: '11px 14px 10px',
      boxShadow: '0 2px 10px rgba(18, 42, 92, 0.06)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span className="ki-denkt-ring" aria-hidden="true" />
        <span key={schritt} className="ki-denkt-zeile" style={{ flex: 1, fontSize: T.tText, color: T.ink, fontWeight: 600 }}>
          {schritte[schritt % schritte.length]}
        </span>
        {/* Nicht vorlesen: Ein Zaehler im Statusbereich wuerde jede Sekunde
            neu angesagt (Code-Review 23.09.2026). */}
        {sekunden >= 3 ? (
          <span aria-hidden="true" style={{ fontSize: T.tMikro, color: T.faint, fontVariantNumeric: 'tabular-nums' }}>{sekunden} s</span>
        ) : null}
      </div>
      <div className="ki-denkt-balken" aria-hidden="true" />
    </div>
  );
}
